import { render, staticRenderFns } from "./Ramais.vue?vue&type=template&id=66bd7ce4&scoped=true&"
import script from "./Ramais.vue?vue&type=script&lang=js&"
export * from "./Ramais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd7ce4",
  null
  
)

export default component.exports